import DataStoreService from './DataStoreService';


export default new DataStoreService(window.localStorage);
